module.exports = __webpack_public_path__ + "img/logo-white.2ff292da.svg";